<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import {
    sourceCleanupInstructionTooltip,
    type SourceCleanupInstructionPresentation,
    type SourceCleanupTooltipField,
  } from "../../_logic/source-cleanup-instruction-tags"

  let {
    instructions = [],
    context = [],
    muted = false,
  }: {
    instructions?: SourceCleanupInstructionPresentation[]
    context?: SourceCleanupTooltipField[]
    muted?: boolean
  } = $props()

  const visibleInstructions = $derived(
    instructions.filter(
      (instruction) => instruction.label && instruction.subLabel && instruction.copyValue,
    ),
  )
</script>

<span class="source-cleanup-instruction-tags" class:muted>
  {#if visibleInstructions.length}
    {#each visibleInstructions as instruction (`${instruction.label}:${instruction.subLabel}:${instruction.copyValue}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={instruction.label}
        subLabel={instruction.subLabel}
        color={instruction.color}
        tooltipContent={sourceCleanupInstructionTooltip(instruction, context)}
        tooltipHtml={true}
        tooltipClassName={RICH_TOOLTIP_CLASS}
        disableTitle={true}
        interaction={{
          kind: "copy",
          resolveValue: () => instruction.copyValue,
          ariaLabel: `${instruction.subLabel}: ${instruction.copyValue} in die Zwischenablage kopieren`,
        }}
      />
    {/each}
  {:else}
    <span class="source-cleanup-instruction-tags__empty">Keine Aktion</span>
  {/if}
</span>

<style>
  .source-cleanup-instruction-tags {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.28rem;
    max-width: 100%;
  }

  .source-cleanup-instruction-tags.muted {
    opacity: 0.54;
  }

  .source-cleanup-instruction-tags__empty {
    color: var(--text-invers-100);
    font-weight: 700;
  }
</style>
